import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import { getPartnerRole } from '../services/user/getPartnerRole';
import { PATH_DASHBOARD } from './paths';

export default function DashboardRedirect() {
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    const determineRedirect = async () => {
      try {
        const currentPartner = JSON.parse(localStorage.getItem('currentPartner'));
        if (currentPartner?._id) {
          const res = await getPartnerRole(currentPartner._id);
          if (res?.role === 'member' || res?.role === 'agent') {
            setRedirectPath(PATH_DASHBOARD.organizations.root);
            return;
          }
        }
      } catch (error) {
        console.error('Error determining redirect:', error);
      }
      setRedirectPath(PATH_DASHBOARD.customers.root);
    };
    determineRedirect();
  }, []);

  if (!redirectPath) {
    return (
      <Stack sx={{ width: '100%', height: '100vh' }} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  return <Navigate to={redirectPath} replace />;
}
